import styles from './StatisticsWidget.module.scss'
import api from 'helpers/api'
import { useEffect, useState } from 'react'
import { FadUsers, FaClinicMedical, FaSync, FaUserMd, FaPowerOff, FaTools, FaQuestionCircle, FaSignOutAlt, FaCog, FaSitemap } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const StatisticsWidget = ({ dateRange }) => {
    const { startDate, endDate } = dateRange;
    const [ stats, setStats ] = useState({});
    const [ isLoaded, setIsLoaded ] = useState(false);

    useEffect(() => {
        if (isLoaded === true) {
            setIsLoaded(false)
        }

        getData().then(res => {
            setStats(res)
        }).catch(e => {
            console.error(e)
        })
    }, [ dateRange ])

    useEffect(() => {
        setIsLoaded(true)
    }, [ stats ])

    const getData = async () => {
        const data = await api.get(`dashboard/general/status?startDate=${startDate}&endDate=${endDate}`)
        return data.data.data;
    }

    return (<>
        <div className={ styles.container }>
            <div className={ styles.statBox }>
                <Link to="/distributors" className='w-100'>
                    <div className={ `alma-box w-100 m-0` }>
                        <div className={ styles.statBody }>
                            <div className={ styles.statIcon }><FaSitemap /></div>
                            <div className={ styles.statContent }>
                                <div className={ styles.statValue }>{ stats.distributors }</div>
                                <h3 className={ styles.statLabel }>Total Distributors</h3>
                            </div>
                        </div>
                    </div>
                </Link>
            </div>
            <div className={ styles.statBox }>
                <Link to="/clinics?type=chain" className='w-100'>
                    <div className={ `alma-box w-100 m-0` }>
                        <div className={ styles.statBody }>
                            <div className={ styles.statIcon }><FaClinicMedical /></div>
                            <div className={ styles.statContent }>
                                <div className={ styles.statValue }>{ stats.chains }</div>
                                <h3 className={ styles.statLabel }>Active Chains</h3>
                            </div>
                        </div>
                    </div>
                </Link>
            </div>
            <div className={ styles.statBox }>
                <Link to="/clinics?type=clinic" className='w-100'>
                    <div className={ `alma-box w-100 m-0` }>
                        <div className={ styles.statBody }>
                            <div className={ styles.statIcon }><FaClinicMedical /></div>
                            <div className={ styles.statContent }>
                                <div className={ styles.statValue }>{ stats.clinics }</div>
                                <h3 className={ styles.statLabel }>Active Clinics</h3>
                            </div>
                        </div>
                    </div>
                </Link>
            </div>
            <div className={ styles.statBox }>
                <Link to="/equipment/applicators" className='w-100'>
                    <div className={ `alma-box w-100 m-0` }>
                        <div className={ styles.statBody }>
                            <div className={ styles.statIcon }><FaCog /></div>
                            <div className={ styles.statContent }>
                                <div className={ styles.statValue }>{ stats.applicators }</div>
                                <h3 className={ styles.statLabel }>Total Applicators</h3>
                            </div>
                        </div>
                    </div>
                </Link>
            </div>
            <div className={ styles.statBox }>
                <Link to="/equipment/platforms" className='w-100'>
                    <div className={ `alma-box w-100 m-0` }>
                        <div className={ styles.statBody }>
                            <div className={ styles.statIcon }><FaCog /></div>
                            <div className={ styles.statContent }>
                                <div className={ styles.statValue }>{ stats.machines }</div>
                                <h3 className={ styles.statLabel }>Total Platforms</h3>
                            </div>
                        </div>
                    </div>
                </Link>
            </div>
            <div className={ styles.statBox }>
                <Link to="/equipment/platforms?offline=true" className='w-100'>
                    <div className={ `alma-box w-100 m-0` }>
                        <div className={ styles.statBody }>
                            <div className={ styles.statIcon }><FaPowerOff /></div>
                            <div className={ styles.statContent }>
                                <div className={ styles.statValue }>{ stats.machinesOffline }</div>
                                <h3 className={ styles.statLabel }>Platforms Offline</h3>
                            </div>
                        </div>
                    </div>
                </Link>
            </div>
        </div>
    </>)
}


export default StatisticsWidget;